// extracted by mini-css-extract-plugin
export default {"ag-styles":"W_g","container":"W_l","quoteBubbleTail":"W_fC","orgContainer":"W_fD","avatar":"W_fF","name":"W_ft","orgIcon":"W_fG"};